import { render } from "./grid.vue?vue&type=template&id=2acbc282&scoped=true&ts=true"
import script from "./grid.vue?vue&type=script&lang=ts"
export * from "./grid.vue?vue&type=script&lang=ts"

import "./grid.vue?vue&type=style&index=0&id=2acbc282&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acbc282"]])

export default __exports__